module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-spinner"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-width": "25%",
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "fa fa-spinner",
    attrs: {
      "id": "spinner"
    }
  }), _vm._v("  \n                    Loading...\n                ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-131daa4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/Spinner.vue
// module id = 1418
// module chunks = 1